import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import {
    Row,
    Col,
    Select,
    Form,
    Button,
    Modal
} from '../../ui/ot'
import MARC008GeneratorForm from "./marc008_generator_form";
import { Plus, X, Settings2 } from 'lucide-react';

const MARC008GeneratorModal = ({
    keyPrefix = "pmis.smartTaskSchedulingTask",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "",
    leader ="",
    tag008 ='' ,
    propsMaterialType="BKS",
    setCount=()=>{},
    onFinish = () => { },
    propsSetOpen = () => { },
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formReloadCount, setFormReloadCount] = useState(0);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
        setCount(pre=>pre+1)
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
    };

    const handleOk = () => {
        setLoading(true);
        form.submit();
        closeModal();
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };

    return (
        <Row>
            <Col>
                {propsOpen === null && (
                    <Button type="primary" onClick={showModal}>
                        {`${openButtonText}`}<Settings2 size={16} />
                    </Button>
                )}
            </Col>
            <Col>
                <Modal
                    title={`${openButtonText}`}
                    open={propsOpen === null ? isModalOpen : propsOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    confirmLoading={propsLoading === null ? loading : propsLoading}
                    maskClosable={false}
                    width={1400}
                    contentStyle={{
                        padding: 16,
                    }}
                    okText={'儲存'}
                    cancelText={'取消'}
                >
                    <Row>
                        <Col span={24}>
                            <MARC008GeneratorForm
                                formReloadCount={formReloadCount}
                                open={propsOpen === null ? isModalOpen : propsOpen}
                                axiosMode={axiosMode}
                                propsForm={form}
                                onFormFinish={onFormFinish}
                                leader ={leader}
                                tag008={tag008}
                                propsMaterialType={propsMaterialType}
                            />
                        </Col>
                    </Row>
                </Modal>
            </Col>
        </Row>
    );
}
export default MARC008GeneratorModal